module.exports = __webpack_public_path__ + "static/media/marchio-bianco.1931a0da.svg";